export enum BillSource {
  AutomatedStatement = 'Automated Statement',
  ClientManualEntry = 'Client Manual Entry',
  EmailedImportFile = 'Emailed Import File',
  EmailedStatement = 'Emailed Statement',
  UploadedImportFile = 'Uploaded Import File',
  UploadedStatement = 'Uploaded Statement',
}
